import { Action, Reducer } from 'redux';
import { UiActions } from './actions';
import { DateFilterType, DateHistoryData } from './interfaces';

export interface UiState {
    navBarOpen: boolean;
    finance: {
        dateFrom: Date | null;
        dateTo: Date | null;
        dateFilter: DateFilterType;
        dateHistory: DateHistoryData[];
    },
}

const initialState: UiState = {
    navBarOpen: true,
    finance: {
        dateFrom: null,
        dateTo: null,
        dateFilter: DateFilterType.CLOSING,
        dateHistory: []
    }
};

export const reducer: Reducer<UiState> = (
    state: UiState | undefined,
    incomingAction: Action
): UiState => {
    if (state === undefined) {
        return initialState;
    }

    const action = incomingAction as UiActions;
    switch (action.type) {
        case 'SWITCH_NAV_BAR':
            return {
                ...state,
                navBarOpen: !state.navBarOpen,
            };
        case 'RESET_FINANCE_DATE_FILTERS':
            return {
                ...state,
                finance: {
                    dateFrom: null,
                    dateTo: null,
                    dateFilter: DateFilterType.CLOSING,
                    dateHistory: []
                }
            };
        case 'SET_FINANCE_DATE_FILTERS':
            return {
                ...state,
                finance: action.payload,
            };
        case 'SET_FINANCE_DATE_FILTER':
            return {
                ...state,
                finance: {
                    ...state.finance,
                    dateFilter: action.payload,
                }
            };
        case 'SET_FINANCE_DATE_HISTORY':
            return {
                ...state,
                finance: {
                    ...state.finance,
                    dateHistory: action.payload,
                }
            };
        case 'SET_FINANCE_DATE_RANGE':
            return {
                ...state,
                finance: {
                    ...state.finance,
                    dateFrom: action.payload.from,
                    dateTo: action.payload.to,
                }
            };
        default:
            return state;
    }
};
